/* eslint-disable react/react-in-jsx-scope */
import {
  Box,
  Container,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from '@chakra-ui/react';
import Agenda from './Agenda';
import AgendaDay2 from './AgendaDay2';

const AgendaLayout = () => (
  <>
    <Box bg="#197542" py="80px" w="100%">
      <Text
        fontWeight="700"
        fontSize={{ xs: '26px', md: '48px' }}
        lineHeight="130%"
        color="#fff"
        textAlign="center"
      >
        Agenda
      </Text>
    </Box>
    {/* <Agenda />
    <AgendaDay2 /> */}
    <Container maxW="container.lg">
      <Tabs w="full" variant="unstyled" display="block" mt={{ xs: '50px' }}>
        <TabList
          width="100%"
          display="flex"
          flexWrap="wrap"
          gap="30px"
          pl={{ md: '80px' }}
          mb={{ md: '-50px' }}
          justifyContent={{ xs: 'center', md: 'start' }}
        >
          <Tab
            color="text.textBlue"
            fontSize="26px"
            fontWeight="700"
            bg="white"
            borderBottom=" 2px solid #197542"
            minW="53px"
            _selected={{
              color: '#197542',

              boxShadow: 'inset 0px -3px 0px #197542',
            }}
            whiteSpace="nowrap"
          >
            Day 1
          </Tab>
          <Tab
            color="text.textBlue"
            fontSize="26px"
            fontWeight="700"
            bg="white"
            pl={{ xs: '16px', lg: '10px', xl: '20px' }}
            pr={{ xs: '30px', lg: '10px', xl: '20px' }}
            borderBottom=" 2px solid #197542"
            minW="53px"
            _selected={{
              color: '#197542',

              boxShadow: 'inset 0px -3px 0px #197542',
            }}
            whiteSpace="nowrap"
          >
            Day 2
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <Agenda />
          </TabPanel>
          <TabPanel>
            <AgendaDay2 />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Container>
  </>
);

export default AgendaLayout;
